import { render, staticRenderFns } from "./SystemAccess.vue?vue&type=template&id=7ca0576b&"
import script from "./SystemAccess.vue?vue&type=script&lang=js&"
export * from "./SystemAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports